/**
 * SEO-Komponente für FirmBay
 * 
 * Setzt Standard-SEO-Meta-Tags für Seiten, die keine eigenen definieren.
 * Wird in App.js als Fallback verwendet.
 * 
 * Einzelne Seiten können diese Tags via Helmet überschreiben.
 */

import { Helmet } from 'react-helmet-async';

// Basis-URL für kanonische URLs (Produktionsumgebung)
export const CANONICAL_BASE = 'https://www.firmbay.de';

// Standard-SEO-Daten für die Homepage/Fallback
export const DEFAULT_SEO = {
  title: 'Firmbay – GmbH kaufen, verkaufen, gründen',
  description: 'Firmbay – Vermittlung von GmbH-Gründungen und Bestandsgesellschaften. Digitaler Marktplatz und persönliche Begleitung für GmbH-Transaktionen in Deutschland. Ein Angebot der Interpohl Solutions GmbH.',
  canonicalUrl: CANONICAL_BASE,
  ogType: 'website',
};

/**
 * DefaultSEO - Fallback SEO-Tags
 * Wird nur verwendet, wenn keine seitenspezifischen Tags gesetzt sind.
 */
const DefaultSEO = () => {
  return (
    <Helmet>
      <title>{DEFAULT_SEO.title}</title>
      <meta name="description" content={DEFAULT_SEO.description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={DEFAULT_SEO.canonicalUrl} />
      
      {/* Open Graph / Social Media */}
      <meta property="og:type" content={DEFAULT_SEO.ogType} />
      <meta property="og:url" content={DEFAULT_SEO.canonicalUrl} />
      <meta property="og:title" content={DEFAULT_SEO.title} />
      <meta property="og:description" content={DEFAULT_SEO.description} />
      <meta property="og:site_name" content="Firmbay" />
    </Helmet>
  );
};

/**
 * PageSEO - Wiederverwendbare SEO-Komponente für statische Seiten
 * @param {object} props - SEO-Eigenschaften
 * @param {string} props.title - Seitentitel
 * @param {string} props.description - Meta-Description
 * @param {string} props.path - Pfad für Canonical-URL (z.B. '/marktplatz')
 * @param {string} props.robots - Robots-Direktive (default: 'index, follow')
 * @param {string} props.ogType - Open Graph Type (default: 'website')
 */
export const PageSEO = ({ 
  title, 
  description, 
  path = '', 
  robots = 'index, follow',
  ogType = 'website'
}) => {
  const canonicalUrl = `${CANONICAL_BASE}${path}`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Social Media */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="Firmbay" />
    </Helmet>
  );
};

export default DefaultSEO;
